import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
// LIBS
import { map, tap } from 'rxjs';
// MODELS
import { UserLogin } from '@models/authentication/UserLogin';
import { User, UserApi } from '@models/authentication/User';
// MAPPERS
import { toLogin } from '@mappers/authentication/login.map';
import { AuthenticationConfigurationService } from './authentication-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private host = `${environment.host}`;
  private url = `${environment.hostAPI}`;

  constructor(private http: HttpClient, private authConfig: AuthenticationConfigurationService) { }

  authenticate({ username, password, systemId }: UserLogin) {
    const url = `${this.host}/token`;
    const data = `username=${username}&password=${password}&grant_type=password&origen_id=${systemId}`;
    return this.http.post<UserApi>(url, data)
      .pipe(map((x: UserApi) => toLogin(x)));

  }

  refreshToken() {
    const url = `${this.host}/token`;
    const {refreshToken} = this.authConfig.getUser();
    const data = `refresh_token=${refreshToken}&grant_type=refresh_token`;
    return this.http.post<UserApi>(url, data)
      .pipe(
        map((x: UserApi) => toLogin(x)),
        tap((user: User) => this.authConfig.setUp(user))
    );
  }

  logout() {
    const url = `${this.url}/users/logout`;
    return this.http.get(url)
    .pipe(tap(() => this.authConfig.clear()));
  }
}
